import type { TopNavV5SubMenu, TopNavV5Tile } from './TopNavV5Props'
import { type TopNavV5Props } from './TopNavV5Props'

const href = '/c/fitness'

export const defaultTiles: TopNavV5Tile[] = [
  {
    image:
      'https://res.cloudinary.com/teambeachbody/image/upload/v1727797937/BODi-Merchandising/BODi%20Storefront%2010-22-24/new%20and%20featured/bbp-enr_1125-750-EN.jpg',
    stamp: 'NEW!',
    title: 'Promotional Item',
    alt: 'Image alt',
    href: '/offers',
    newTab: false,
    isVisible: true,
  },
  {
    image:
      'https://res.cloudinary.com/teambeachbody/image/upload/v1727797937/BODi-Merchandising/BODi%20Storefront%2010-22-24/new%20and%20featured/bbp-enr_1125-750-EN.jpg',
    stamp: 'NEW!',
    title: 'Promotional Item',
    alt: 'Image alt',
    href: '/offers',
    newTab: false,
    isVisible: true,
  },
]

export const supplementsSubMenu: TopNavV5SubMenu = {
  title: 'Supplements',
  ctaDesktop: {
    title: 'Shop Supplements',
    href,
  },
  hasCtaMobile: true,
  ctaMobile: {
    title: 'Shop Supplements',
    href,
  },
  tiles: defaultTiles.slice(0, 1),
  items: [
    {
      title: 'All-in-One Daily Nutrition',
      links: [
        {
          title: 'Shakeology Original',
          href,
        },
        {
          title: 'Shakeology 0g Added Sugar',
          href,
          stamp: 'NEW!',
        },
        {
          title: 'Shakeology Sample Packs',
          href,
        },
        {
          title: 'Shakeology Flavor Variety Pack',
          href,
        },
      ],
    },
    {
      title: 'Sport Nutrition',
      links: [
        {
          title: 'Energize Pre-Workout',
          href,
        },
        {
          title: 'Recover Post-Workout',
          href,
        },
        {
          title: 'Hydrate Electrolytes',
          href,
        },
      ],
    },
    {
      title: 'Hormone Health',
      links: [
        {
          title: 'Belle Vitale Supplements',
          href,
          stamp: 'NEW!',
        },
      ],
    },
  ],
}

const programsSubMenu: TopNavV5SubMenu = {
  title: 'Programs',
  ctaDesktop: {
    title: 'View All Programs',
    href,
  },
  hasCtaMobile: true,
  ctaMobile: {
    title: 'View All Programs',
    href,
  },
  tiles: defaultTiles,
  items: [
    {
      title: 'Best Sellers',
      links: [
        {
          title: 'P90X',
          href,
        },
        {
          title: 'LIIFT4',
          href,
          stamp: 'NEW!',
        },
        {
          title: 'DIG DEEPER',
          href,
        },
        {
          title: '25 Minutes',
          href,
        },
      ],
    },
    {
      title: 'Newest Releases',
      links: [
        {
          title: 'P90X V2',
          href,
        },
        {
          title: 'LIIFT5',
          href,
        },
        {
          title: 'DIG EVEN DEEPER',
          href,
        },
      ],
    },
  ],
}

export const defaultTopNavV5Props: TopNavV5Props = {
  logo: {
    href: '/',
    altText: 'Bodi logo',
    src: 'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fbe73d1e15bab4510b776037797f287d3',
    desktopWidth: 99,
    desktopHeight: 32,
    mobileWidth: 76,
    mobileHeight: 24,
  },
  mobileFooterLinks: [
    {
      title: 'Contact Us / FAQ',
      href: 'https://faq.beachbody.com/app/home?locale=en_US',
      newTab: true,
    },
  ],
  account: {
    signOutCopy: 'Sign out',
    bodiCta: {
      href: '/offers',
      title: 'Get BODi',
    },
    links: [
      {
        title: 'Account Settings',
        href: 'https://www.teambeachbody.com/shop/us/account/settings',
        newTab: true,
      },
      {
        title: 'Orders',
        href: 'https://www.teambeachbody.com/shop/us/account/settings?locale=en_us&tab=MyOrders',
        newTab: true,
      },
      {
        title: 'Subscriptions',
        href: 'https://www.teambeachbody.com/shop/us/account/settings?locale=en_us&tab=membershipsandsubscriptions',
        newTab: true,
      },
    ],
    welcomeCopy: 'Welcome back',
    title: 'Account', // logged in title
    loggedOutTitle: 'Login or Join BODi',
    loggedOutSubtitle: 'Workouts, nutrition, and much more.',
    logInCopy: 'Login',
    loggedInLinks: [
      {
        title: 'BODi App',
        href: 'https://www.beachbodyondemand.com',
        newTab: true,
        subtitle: 'Your workouts, tracking, & more',
        imageAlt: 'BODi logo',
        imageUrl:
          'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F7382a7596e3e48cfb0bc48648db99446?width=200&height=200',
      },
    ],
  },
  items: [
    {
      title: 'Left Menu type',
      subMenuType: 'leftMenu',
      stamp: 'NEW!',
      leftMenuItems: [supplementsSubMenu, programsSubMenu],
    },
    {
      title: 'Sub Menu type',
      subMenuType: 'subMenu',
      subMenu: programsSubMenu,
    },

    {
      title: 'Mini Menu type',
      subMenuType: 'miniMenu',
      miniMenuItems: [
        {
          title: 'Subscription Plans',
          href,
        },
        {
          title: 'The Total Solution',
          href,
        },
        {
          title: 'Community',
          href,
          stamp: 'NEW!',
        },
        {
          title: 'Success Stories',
          href,
        },
        {
          title: 'Become an Affilate',
          href,
        },
        {
          title: 'Blog',
          href,
        },
      ],
    },
    {
      title: 'Link type',
      subMenuType: 'link',
      link: { href, newTab: true },
    },
  ],
}
